import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { setLastWorkspaceId } from '@/shared/lib/last-workspace'

export const Route = createFileRoute('/$lang/workspace/$workspaceId/agents/')({
  beforeLoad: ({ context, params }) => {
    requireAuthenticated(context, params)
    setLastWorkspaceId(params.workspaceId)

    throw redirect({
      to: '/$lang/organization/agents',
      params: { lang: params.lang },
      replace: true,
    })
  },
})
